import * as React from 'react';
import * as _ from 'lodash-es';
import cx from 'classnames';
import Paper from '@mui/material/Paper';
import Table from '@mui/material/Table';
import TableBody from '@mui/material/TableBody';
import TravelPolicyTableRows from './TravelPolicyTableRows';
import Loader from 'components/Loader/Loader';
import { BudgetPolicy } from './travelPolicy.interface';
import { TravelPolicyTabTypes } from '../../UserDetails/UserDetail';

const styles = require('./styles.pcss');

type Props = {
  isLoading: boolean;
  product: TravelPolicyTabTypes;
  budgetPolicy?: BudgetPolicy;
};

const budgetClass: any = {
  name: 'Class',
  description: 'Fare Class or Hotel Class that the budget will be based on.',
};

const comfort: any = {
  name: 'Comfort',
  description:
    'Number of stops or distance from search that the budget will be based on.',
};

class BudgetRules extends React.Component<Props> {
  constructor(props: Props) {
    super(props);
  }

  onFormatLabels({
    hotelRating,
    flightComfort,
    hotelDistance,
  }: {
    hotelRating: number | string | undefined;
    flightComfort: string | boolean | undefined;
    hotelDistance: number | undefined;
  }) {
    const isFlightComfortBool = typeof flightComfort == 'boolean';

    return {
      hotelRating: hotelRating ? hotelRating + ' Star' : '-',
      flightComfort:
        isFlightComfortBool && flightComfort
          ? 'Nonstop'
          : isFlightComfortBool && !flightComfort
            ? '1+ Stops'
            : '-',
      hotelDistance: hotelDistance ? hotelDistance + ' miles' : '-',
    };
  }

  render() {
    const { isLoading, product, budgetPolicy = {} } = this.props;

    let flightClass, hotelRating, flightComfort, hotelDistance;
    flightClass = budgetPolicy?.airClass;

    ({ hotelRating, hotelDistance, flightComfort } = this.onFormatLabels({
      hotelRating: budgetPolicy?.hotelRating,
      flightComfort: budgetPolicy?.airNonStop,
      hotelDistance: budgetPolicy?.hotelDistance,
    }));

    return (
      product !== TravelPolicyTabTypes.car && (
        <Paper
          className={
            isLoading ? cx(styles.paper, styles.loading) : styles.paper
          }
        >
          <div className={styles.policyRules}>
            <h2>Budget</h2>
            <div>
              <Loader visible={isLoading} />
            </div>
            <Table>
              <TableBody>
                <TravelPolicyTableRows
                  key={1}
                  product={product}
                  text={budgetClass}
                  flight={flightClass}
                  hotel={hotelRating}
                />
                <TravelPolicyTableRows
                  key={2}
                  product={product}
                  text={comfort}
                  flight={flightComfort}
                  hotel={hotelDistance}
                />
              </TableBody>
            </Table>
          </div>
        </Paper>
      )
    );
  }
}

export default BudgetRules;
